import { BrowserAuthOptions, Configuration, PopupRequest } from "@azure/msal-browser";

// Config object to be passed to Msal on creation
const authOptions: BrowserAuthOptions = {
  clientId: `${process.env.REACT_APP_AD_CLIENT_ID}`,
  authority: `${process.env.REACT_APP_AD_AUTHORITY}${process.env.REACT_APP_AD_TENANT}`,
  redirectUri: window.location.origin,
  postLogoutRedirectUri: window.location.origin,
  navigateToLoginRequestUrl: false,
};

export const MsalConfig: Configuration = {
  auth: authOptions,
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
// Test
// export const loginRequest: PopupRequest = {
//   scopes: ["api://36fc6bcb-ead5-4b45-af19-acc69efca1d1/dpdhl-webapi.Read"],
// };

// prd app
export const loginRequest: PopupRequest = {
  scopes: ["api://750846b6-ce0c-4616-92a0-c90079baf73b/dpdhl-webapi.Read"],
};
